import { createSelector } from '@reduxjs/toolkit'
import { RootStoreModel } from '../store.model'

const pricingState = (store: RootStoreModel) => store.pricingState

export const selectCoefficients = createSelector(pricingState, state => state.coefficients)
